import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showRegistrationConfirmationModal: false,
  showContactModal: false,
};

const app = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setShowRegistrationConfirmationModal: (state, action) => {
      state.showRegistrationConfirmationModal = action.payload;
    },
    setShowContactModal: (state, action) => {
      state.showContactModal = action.payload;
    },
  },
});

export const {
  setShowRegistrationConfirmationModal,
  setShowContactModal,
} = app.actions;

export default app.reducer;
